<template>
    <RouterLink class="underline" to="/carbucks-privacy-policy">Privacy Policy</RouterLink>
</template>